import { api, idemKey, bidzChanged } from "./api";

const loadScript = () => new Promise((resolve, reject) => {
  if (window.Razorpay) return resolve();
  const s = document.createElement("script");
  s.src = "https://checkout.razorpay.com/v1/checkout.js";
  s.onload = () => resolve();
  s.onerror = () => reject(new Error("Could not load Razorpay checkout"));
  document.body.appendChild(s);
});

// Opens Razorpay checkout; resolves with the verified purchase, rejects on failure/dismiss.
export async function payWithRazorpay(body, key = idemKey()) {
  await loadScript();
  const { data: o } = await api.post("/payments/razorpay/order", body, { headers: { "Idempotency-Key": key } });
  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: o.key_id, order_id: o.order_id, amount: o.amount, currency: o.currency,
      name: o.name, description: o.description, prefill: o.prefill, theme: { color: "#f59e0b" },
      handler: async (resp) => {
        try {
          const { data } = await api.post("/payments/razorpay/verify", resp);
          bidzChanged();
          resolve(data);
        } catch (e) { reject(e); }
      },
      modal: {
        ondismiss: () => {
          api.post("/payments/razorpay/cancel", { razorpay_order_id: o.order_id }).catch(() => {});
          reject(new Error("Payment cancelled"));
        },
      },
    });
    rzp.on("payment.failed", (r) => {
      api.post("/payments/razorpay/cancel", { razorpay_order_id: o.order_id, reason: r?.error?.code || "payment_failed" }).catch(() => {});
      reject(new Error(r?.error?.description || "Payment failed"));
    });
    rzp.open();
  });
}

export const payErr = (e) => (typeof e?.response?.data?.detail === "string" ? e.response.data.detail : e?.message || "Payment failed");
